<template>
  <div class="animated fadeIn mb-3">
    <b-row class="mb-3">
      <b-col md="3" class="pt-2">Identifier</b-col>
      <b-col>
        <b-input-group>
          <b-form-select
            v-model="sample_form.customer_field_id"
            :options="customer_field_options"
          >
            <template slot="first">
              <option :value="null">
                Select Field
              </option>
            </template>
          </b-form-select>
        </b-input-group>
      </b-col>
      <b-col>
        <b-input-group>
          <b-form-input
            type="text"
            v-model="sample_form.identifier"
            placeholder="Sample Name"
            :state="!$v.sample_form.identifier.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Harvest Date" :label-cols="3">
          <b-form-input
            type="date"
            v-model="sample_form.harvest_date"
            placeholder="Sample Harvest Date"
            :state="!$v.sample_form.harvest_date.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Field" :label-cols="3">
          <b-form-input
            type="text"
            v-model="sample_form.field"
            placeholder="Sample Field"
            :state="!$v.sample_form.field.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pr-3" align-h="end">
      <b-col md="1.5">
        <b-button variant="success" block @click="update('duplicate')"
          ><i class="fa fa-plus"></i> Duplicate</b-button
        >
      </b-col>
      <template v-if="sampleListLength > 1">
        <b-col md="1.5" class="ml-2">
          <b-button variant="danger" block @click="update('remove')"
            ><i class="fa fa-trash"></i> Remove</b-button
          >
        </b-col>
      </template>
    </b-row>
    <hr />
  </div>
</template>
<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PotatoSampleFormGroup",
  mixins: [validationMixin, ToastNotifications],
  props: {
    sample: {
      type: Object,
      default: () => null
    },
    sampleListLength: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: null
    },
    customer_field_options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sample_form: {
        identifier: null,
        harvest_date: null,
        field: null,

        customer_field_id: null
      },
    };
  },
  validations: {
    sample_form: {
      identifier: { required },
      harvest_date: { required },
      field: { required }
    }
  },
  methods: {
    update(action) {
      this.$emit("onSampleListChange", { action, index: this.index });
    }
  },
  watch: {
    sample_form: {
      handler() {
        this.$emit("onSampleChange", {
          sample: {
            ...this.sample,
            identifier: this.sample_form.identifier,
            sample_potato: {
              harvest_date: this.sample_form.harvest_date,
              field: this.sample_form.field
            }
          },
          index: this.index
        });
      },
      deep: true
    },
    sample: {
      handler(value) {
        this.sample_form.identifier = value.identifier;
        this.sample_form.field = value.sample_potato.field;
        this.sample_form.harvest_date = value.sample_potato.harvest_date;
      },
      deep: true,
      immediate: true
    },
    customer_field_options: {
      handler(value) {
        this.sample_form.customer_field_id = null
      },
      immediate: true,
      deep: true
    },
    'sample_form.customer_field_id': {
      handler(value) {
        if (value) {
          this.sample_form.identifier = this.customer_field_options.find((field) => field.value === value).text
        } else {
          this.sample_form.identifier = null
        }
      },
      immediate: true
    }
  }
};
</script>
